import { IContent } from "src/components/HeroSection";

interface IParagraphSections {
  heading: string;
  textSection: string[];
}

interface ITiledParagraphSections {
  icon: "electricity" | "usage";
  heading: string;
  textSection: string[];
  cta?: {
    url: string;
    text: string;
  };
}

export enum Version {
  V1 = "1",
  V2 = "2",
}

export interface IHeroContent extends IContent {
  secondaryLink: {
    link: string;
    text: string;
  };
}

export interface ISpikeContent {
  heroContent: IHeroContent;
  paragraphContent: IParagraphContent;
  tileParagraphContent: ITiledParagraphContent;
  registerContent: IRegisterContent;
}

export interface IParagraphContent {
  sections: IParagraphSections[];
  cta?: {
    url: string;
    text: string;
  };
}

export interface ITiledParagraphContent {
  sections: ITiledParagraphSections[];
}

export interface IRegisterContent {
  heading: string;
  icon: string;
  cta: { text: string; prodLocation: string; nonProdLocation: string };
}
